import useUserStore from '~~/app/store/user'
import { decodeJwtToken } from '~~/app/utils/cookie'

export default defineNuxtRouteMiddleware(async () => {
    if (process.env.MODE === 'test') return
    const userStore = useUserStore()

    const session = useUserSession().session.value?.tokens?.accessToken
    const userId = useUserSession().user?.value?.id

    let isBoostUser: boolean | undefined

    if (session) {
        ;[isBoostUser] = decodeJwtToken(session)
    }

    // User related actions
    if (userId) {
        await userStore.fetchCommunityUserUserData(userId)
        await userStore.fetchUserAddresses()
        await userStore.checkIfUserHasChargemapPass()
        await userStore.fetchUserTeslaLinkStatus()

        if (isBoostUser) {
            userStore.isBoostUser = isBoostUser
        }
    }
})
